import Phaser from 'phaser';
import { ASSET_V } from './Preload';

// Articulated rig parts per animal (tail only where it has one). These + the stadium backdrop are
// the heavy IN-RACE assets (~12MB) — not needed for the menu.
const RIG_PARTS: Record<string, boolean> = {
  cheetah: true, meerkat: true, kangaroo: true,
  sloth: false, gorilla: false, capybara: false, ostrich: false, hare: false, elephant: false,
};

/**
 * Loads the heavy in-race assets (stadium + rig parts) AFTER the menu is interactive, as a
 * persistent parallel scene. This keeps the INITIAL download (what CrazyGames measures up to
 * loadingStop) small enough for their mobile-homepage budget, with zero quality change — the
 * assets simply arrive in the background while the player is in the menus, well before any race.
 */
export class BackgroundLoad extends Phaser.Scene {
  constructor() {
    super({ key: 'BackgroundLoad', active: false });
  }

  preload(): void {
    const v = (p: string): string => `${p}?v=${ASSET_V}`;
    // Stadium first — every race needs it.
    if (!this.textures.exists('stadium')) this.load.image('stadium', v('assets/backgrounds/stadium.png'));
    for (const [animal, hasTail] of Object.entries(RIG_PARTS)) {
      const parts = hasTail ? ['head', 'torso', 'arm', 'leg', 'tail'] : ['head', 'torso', 'arm', 'leg'];
      for (const part of parts) {
        const key = `${animal}_part_${part}`;
        if (!this.textures.exists(key)) this.load.image(key, v(`assets/sprites/parts/${animal}/${part}.png`));
      }
    }
  }

  create(): void {
    this.scene.sleep(); // idle but alive, so its loaded textures stay cached for the race scenes
  }
}
